import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { PersistGate } from 'redux-persist/integration/react'; //delays rendering of app UI until persisted state has been retried and saved in redux
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { BrowserRouter } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';

console.log(persistor);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</React.StrictMode>
);

// Unregistered intentionally: the service worker's cache-first strategy was serving
// stale JS bundles to returning users for many minutes after a deploy, so bug fixes
// wouldn't reach them without a manual hard refresh. The app has no offline mode, so
// the SW provided no benefit. Calling unregister() here also tears down any SW that
// existing users still have installed from a prior build.
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
